export class Dashboard{
    constructor(
        {   id = null,
            origemId = null,
            escolaCodigo = null,

        }) {
        this.id = id;
        this.origemId = origemId;
        this.escolaCodigo = escolaCodigo;

    }

    static Build() {
        return new Dashboard({
            id: null,
            origemId: null,
            escolaCodigo: null,
        });
    }
}
